export default (props)=>{
    const colorClass = props.color?' has-'+props.color+'-color':' no-color';
    const fixed_size = props.fixedSize?' fa-fw':'';
    return <i className={ 'cdm-font-awesome'+colorClass+fixed_size+' size-icon-'+props.size+' fa-'+props.style+' '+'fa-'+props.iconId + ' has-text-align-'+(props.align ?? 'left')}></i>
}